// @core/api/endpoints/user/list_invited_users.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListInvitedUsersResponse,
} from '../../../types/user';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/user';

/**
 * List users invited by current user
 * Returns a paginated list of users who signed up using the current user's referral link or code. Useful for tracking referral program success and rewards.
 */
export async function ListInvitedUsers(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListInvitedUsersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invited`;
  const requestOptions = options;
  return client.get<ListInvitedUsersResponse>(requestPath, { ...requestOptions, params });
}
